import React from 'react';
import PropTypes from 'prop-types';
import { PlayerCard } from '../../cards';
import styles from './playersDisplay.scss';

const PlayersCardList = (props) => {
    const { players,
        onShowAllClick,
        clubProfileViewType,
        showAllLinkVisible,
        showAllLinkText,
        isAdminOrOwner,
        sendMessage,
        showTennisRatings = true,
        showPickleBallRatings = false,
        checkGate,
        featureGates,
    } = props;
    if (players && players.length > 0) {
        return (
            <div className={`${styles.playersDisplay}`}>
                <div className="row">
                    {players.map((player, i) => {
                        return (
                            <div
                                className="col-12"
                                key={`player-${i}`}
                            >
                                <PlayerCard
                                    player={player}
                                    clubProfileViewType={clubProfileViewType}
                                    showDecimals={isAdminOrOwner}
                                    sendMessage={sendMessage}
                                    showTennisRatings={showTennisRatings}
                                    showPickleBallRatings={showPickleBallRatings}
                                    checkGate={checkGate}
                                    featureGates={featureGates}
                                />
                            </div>
                        );
                    })}
                </div>
                {showAllLinkVisible && (
                    <div
                        className={`link clickable mt16 mb8`}
                        onClick={(ev) => {
                            onShowAllClick(ev);
                        }}
                    >
                        {showAllLinkText || `Show All`}
                    </div>
                )}
            </div>
        );
    }
    return (
        <p>No players added yet</p>
    );
};

PlayersCardList.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    players: PropTypes.array,
    onShowAllClick: PropTypes.func,
    clubProfileViewType: PropTypes.string,
    showAllLinkVisible: PropTypes.bool,
    showAllLinkText: PropTypes.string,
    isAdminOrOwner: PropTypes.bool,
    sendMessage: PropTypes.func,
    showTennisRatings: PropTypes.bool,
    showPickleBallRatings: PropTypes.bool,
    checkGate: PropTypes.func,
    // eslint-disable-next-line react/forbid-prop-types
    featureGates: PropTypes.object,
};

PlayersCardList.defaultProps = {
    players: [],
    onShowAllClick: null,
    clubProfileViewType: null,
    showAllLinkVisible: false,
    showAllLinkText: null,
    isAdminOrOwner: false,
    sendMessage: null,
    showTennisRatings: true,
    showPickleBallRatings: false,
    checkGate: null,
    featureGates: null,
};

export default PlayersCardList;
